import { CalendarDays, Clock3, Link, MapPin, Video, X } from "lucide-react";
import "./EditGameDetailsModal.css";

function EditGameDetailsModal({
 formData,
 setFormData,
 handleUpdateGameDetails,
 setShowModal,
}) {
 return (
  <div className="edit-game-modal-backdrop">
   <div className="edit-game-modal-card">
    <div className="edit-game-modal-header">
     <div>
      <h2>Edit Game Details</h2>
      <p>Update the public game information.</p>
     </div>

     <button
      type="button"
      className="edit-game-modal-close"
      onClick={() => setShowModal(false)}
     >
      <X size={20} strokeWidth={2.3} />
     </button>
    </div>

    <form className="edit-game-modal-form" onSubmit={handleUpdateGameDetails}>
     <div className="edit-game-field">
      <label>Video URL</label>
      <div className="edit-game-input-wrap">
       <Video size={18} strokeWidth={2.2} />
       <input
        type="text"
        placeholder="https://youtube.com/..."
        value={formData.video_url}
        onChange={(e) =>
         setFormData({ ...formData, video_url: e.target.value })
        }
       />
      </div>
     </div>

     <div className="edit-game-field">
      <label>Location</label>
      <div className="edit-game-input-wrap">
       <MapPin size={18} strokeWidth={2.2} />
       <input
        type="text"
        placeholder="Gym, park, court..."
        value={formData.location}
        onChange={(e) =>
         setFormData({ ...formData, location: e.target.value })
        }
       />
      </div>
     </div>

     <div className="edit-game-field">
      <label>Location URL</label>
      <div className="edit-game-input-wrap">
       <Link size={18} strokeWidth={2.2} />
       <input
        type="text"
        placeholder="Google Maps link"
        value={formData.location_url}
        onChange={(e) =>
         setFormData({ ...formData, location_url: e.target.value })
        }
       />
      </div>
     </div>

     <div className="edit-game-modal-grid">
      <div className="edit-game-field">
       <label>Time</label>
       <div className="edit-game-input-wrap">
        <Clock3 size={18} strokeWidth={2.2} />
        <input
         type="time"
         value={formData.time}
         onChange={(e) =>
          setFormData({ ...formData, time: e.target.value })
         }
        />
       </div>
      </div>

      <div className="edit-game-field">
       <label>Date</label>
       <div className="edit-game-input-wrap">
        <CalendarDays size={18} strokeWidth={2.2} />
        <input
         type="date"
         value={formData.date || ""}
         onChange={(e) =>
          setFormData({ ...formData, date: e.target.value })
         }
        />
       </div>
      </div>
     </div>

     <div className="edit-game-modal-actions">
      <button
       type="button"
       className="edit-game-cancel-btn"
       onClick={() => setShowModal(false)}
      >
       Cancel
      </button>

      <button type="submit" className="edit-game-save-btn">
       Save Changes
      </button>
     </div>
    </form>
   </div>
  </div>
 );
}

export default EditGameDetailsModal;